const text = (value) => (value === null || value === undefined ? '' : String(value));
const PLACEHOLDER = '[missing]';

const variablesFor = ({ row = {}, context = {} } = {}) => ({
  bac: text(row.bac),
  dealer: text(row.dealerName || row.dealerDisplayName || row.accountMatchSummary?.displayName),
  productCode: text(context.productCode || row.productCode || row.oemProductCode),
  oldPrice: text(context.oldPrice ?? context.price ?? row.oldPrice),
  newPrice: text(context.newPrice ?? row.newPrice),
  replacementProductCode: text(context.replacementProductCode || context.customProductCode || row.replacementProductCode),
  sourceLane: text(context.sourceLabel || context.source || row.source),
  targetLane: text(context.targetLabel || context.target),
  evidenceId: text(context.evidenceId || context.orderItemId || context.referenceId || row.orderItemId || row.referenceId),
});

const fill = (template, variables) => template.replace(/\{\{(\w+)\}\}/g, (_match, key) => variables[key] || PLACEHOLDER);

export const NOTE_TEMPLATES = [
  {
    id: 'remove_from_gm',
    label: 'Remove from GM',
    text: 'Remove {{productCode}} from GM for {{dealer}} (BAC {{bac}}). Driver: product should not bill in GM. Evidence: {{evidenceId}}.',
  },
  {
    id: 'add_to_gm',
    label: 'Add to GM',
    text: 'Add {{productCode}} to GM for {{dealer}} (BAC {{bac}}). Source lane: {{sourceLane}}. Evidence: {{evidenceId}}.',
  },
  {
    id: 'remove_from_cpq',
    label: 'Remove from CPQ',
    text: 'Remove {{productCode}} from CPQ/PeopleSoft review for {{dealer}} (BAC {{bac}}). Evidence: {{evidenceId}}.',
  },
  {
    id: 'add_to_cpq',
    label: 'Add to CPQ',
    text: 'Add {{productCode}} to CPQ/PeopleSoft review for {{dealer}} (BAC {{bac}}). Source lane: {{sourceLane}}. Evidence: {{evidenceId}}.',
  },
  {
    id: 'change_price',
    label: 'Change price',
    text: 'Change {{productCode}} price from {{oldPrice}} to {{newPrice}} for {{dealer}} (BAC {{bac}}). Evidence: {{evidenceId}}.',
  },
  {
    id: 'replace_product',
    label: 'Replace product',
    text: 'Replace {{productCode}} with {{replacementProductCode}} for {{dealer}} (BAC {{bac}}). Price: {{oldPrice}} to {{newPrice}}. Evidence: {{evidenceId}}.',
  },
  {
    id: 'accept_manual',
    label: 'Accept/manual',
    text: 'Manual variance accepted for {{dealer}} (BAC {{bac}}). Reviewed product {{productCode}} and evidence {{evidenceId}}.',
  },
];

export const applyNoteTemplate = ({ templateId, row, context } = {}) => {
  const template = NOTE_TEMPLATES.find((entry) => entry.id === templateId);
  if (!template) return '';
  return fill(template.text, variablesFor({ row, context }));
};

export const noteQuality = (note = '') => {
  const trimmed = text(note).trim();
  if (!trimmed) return { status: 'empty', label: 'No note', color: 'default' };
  if (trimmed.includes(PLACEHOLDER)) return { status: 'thin', label: 'Needs driver/evidence', color: 'warning' };
  const hasAction = /\b(add|remove|change|replace|accept|manual|fix|correct)\b/i.test(trimmed);
  const hasEvidence = /\b(802|ref|reference|order|evidence|bac|gm|cpq|appsheet|dpe)\b/i.test(trimmed);
  if (trimmed.length >= 35 && hasAction && hasEvidence) return { status: 'ready', label: 'Export-ready note', color: 'success' };
  return { status: 'thin', label: 'Needs driver/evidence', color: 'warning' };
};
